import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'camelCase' })
export class CamelCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }
    return value
      .split(' ')
      .map(v => this.capitalize(v))
      .join(' ');
  }

  capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

}
